import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import LoggerService from "@bfx/logger";
const _logger = LoggerService.for(__dirname);

/**
 * Component wrapping all Design Specs for a simple bfx badge. Currently size is always "sm" but can
 * exptend when needed to add support for ther sizes (styles already exist)
 */
type IntentType = "neutral" | "warning" | "positive" | "negative" | "info";
type EmphasisType = "bold" | "moderate" | "subtle";

@Component({
  selector: "bfx-badge",
  template: `
    <div [class]="badgeClass">
      <i *ngIf="showIcon" [class]="iconClass"></i>
      <span class="badge-text">{{ badgeText }}</span>
    </div>
  `,
  standalone: false,
})
export class BfxBadgeComponent implements OnChanges {
  @Input() id: string;

  /** should the badge icon be shown - default is false */
  @Input() showIcon: boolean = false;

  /** Intent - one of "neutral" | "warning" | "positive" | "negative" | "info" */
  @Input() intent: IntentType = "neutral";

  /** emphasis - one of   "bold" | "moderate" | "subtle" */
  @Input() emphasis: EmphasisType = "moderate";

  /** Text to appear inside the badge  */
  @Input() badgeText: string = "";

  /** non-api property used by template for displaying the icon */
  public iconClass: string = "icon_ion_info_filled";

  /** non-api property used by template for displaying the badge */
  public badgeClass: string = "bfx-badge-neutral-moderate";

  constructor() {
    //
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.badgeClass = `bfx-badge-${this.intent}-${this.emphasis}`;
    switch (this.intent) {
      case "neutral":
      case "info":
        this.iconClass = "icon_ion_info";
        break;
      case "warning":
        this.iconClass = "icon_ion_warning";
        break;
      case "positive":
        this.iconClass = "icon_ion_check_circle";
        break;
      case "negative":
        this.iconClass = "icon_ion_error";
        break;
      default:
        this.iconClass = "icon_ion_info";
        break;
    }
  }
}
